import React, { useState } from "react";
import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogContent,
    CircularProgress,
} from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import { Backdrop } from "@material-ui/core";

const OldDateWarning = ({ open, close  ,InvalidWarningDateState  }) => {
    return (
        <Dialog open={open} onClose={close} fullWidth={true}>
            <DialogContent>
                {/* <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop> */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                >
                    <HelpOutline color="secondary" fontSize="large" mt={2} />
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                    p={2}
                    mt={1}
                >
                    <Typography variant="h4" style={{ width: "80%" }}>
                     {/* Warning : Invoice date is more than 6 months old */}
                     {InvalidWarningDateState}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                    m={1}
                >
                    
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={close}
                        style={{ marginLeft: "20px" }}
                    >
                        Ok
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default OldDateWarning;
